// src/store/sagas/commentSagas.ts
import { call, put, takeLatest, all } from 'redux-saga/effects';
import {
    fetchCommentsRequest,
    fetchCommentsSuccess,
    fetchCommentsFailure,
    createCommentRequest,
    createCommentSuccess,
    createCommentFailure,
    deleteCommentRequest,
    deleteCommentSuccess,
    deleteCommentFailure
} from '../actions/commentActions';
import { CommentItem } from '../../types/commentTypes';
import { commentApi } from '../../api/commentApi';

function* fetchCommentsSaga(action: ReturnType<typeof fetchCommentsRequest>) {
    try {
        const res: CommentItem[] = yield call(commentApi.getComments, action.payload);
        yield put(fetchCommentsSuccess(res));
    } catch (e: any) {
        yield put(fetchCommentsFailure(e.message));
    }
}

function* createCommentSaga(action: ReturnType<typeof createCommentRequest>) {
    try {
        const res: CommentItem = yield call(commentApi.createComment, action.payload);
        yield put(createCommentSuccess(res));

        yield put(fetchCommentsRequest(action.payload.boardId));
    } catch (e: any) {
        yield put(createCommentFailure(e.message));
    }
}

function* deleteCommentSaga(action: ReturnType<typeof deleteCommentRequest>) {
    try {
        const { commentId, userId } = action.payload;
        yield call(commentApi.deleteComment, commentId, userId);
        yield put(deleteCommentSuccess(commentId)); // 삭제된 댓글 ID만 전달
    } catch (e: any) {
        yield put(deleteCommentFailure(e.message));
    }
}

export default function* commentSagas() {
    yield all([
        takeLatest(fetchCommentsRequest.type, fetchCommentsSaga),
        takeLatest(createCommentRequest.type, createCommentSaga),
        takeLatest(deleteCommentRequest.type, deleteCommentSaga),
    ]);
}
